var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"py-4",class:`col-sm-${_vm.size} col-md-${_vm.size}`},[_c('div',{class:`alert-message alert-message-${_vm.type}`},[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }